import cancello_ingresso1 from '../../photos/Case/Facciata/cancello ingresso 1.jpg';
import cancello_ingresso2 from '../../photos/Case/Facciata/cancello ingresso 2.jpg';

import esterno_piano_terra1 from '../../photos/Case/Facciata/esterno piano terra 1.jpg';
import esterno_piano_terra2 from '../../photos/Case/Facciata/esterno piano terra 2_sfondo_orizzontale.jpg';
import esterno_piano_terra3 from '../../photos/Case/Facciata/esterno piano terra 3_sfondo_verticale.jpg';

import giardino1 from '../../photos/Case/Facciata/giardino 1.jpg';
import giardino2 from '../../photos/Case/Facciata/giardino 2.jpg';
import particolare_giardino1 from '../../photos/Case/Facciata/Particolare giardino 1.jpg';
import particolare_giardino2 from '../../photos/Case/Facciata/Particolare giardino 2.jpg';
import particolare_giardino3 from '../../photos/Case/Facciata/Particolare giardino 3.jpg';
import particolare_giardino4 from '../../photos/Case/Facciata/Particolare giardino 4.jpg';
import particolare_giardino5 from '../../photos/Case/Facciata/Particolare giardino 5.jpg';
import particolare_giardino6 from '../../photos/Case/Facciata/Particolare giardino 6.jpg';

import gradini_accesso from '../../photos/Case/Piano terra/Esterno piano terra/Gradini accesso.jpg';
import balconcino_ingresso from '../../photos/Case/Piano terra/Esterno piano terra/Balconcino ingresso.jpg';
import accesso_veranda from '../../photos/Case/Piano terra/Esterno piano terra/Accesso veranda.jpg';
import veranda1 from '../../photos/Case/Piano terra/Esterno piano terra/Veranda 1.jpg';
import cucina_esterna from '../../photos/Case/Piano terra/Esterno piano terra/Cucina esterna.jpg';
import barbecue from '../../photos/Case/Piano terra/Esterno piano terra/Barbecue.jpg';

import cucina_interna from '../../photos/Case/Piano terra/Cucina interna.jpg';
import frigo from '../../photos/Case/Piano terra/Frigorifero.jpg';
import divano_soggiorno from '../../photos/Case/Piano terra/Divano soggiorno.jpg';
import tavolo_cucina from '../../photos/Case/Piano terra/Tavolo cucina.jpg';
import vista_cucina from '../../photos/Case/Piano terra/Vista dalla cucina.jpg';
import camera_matr from '../../photos/Case/Piano terra/Camera matrimoniale.jpg';
import armadio_camera_matr from '../../photos/Case/Piano terra/Armadio camera matrimoniale.jpg';
import camera_doppia from '../../photos/Case/Piano terra/Camera doppia.jpg';
import armadio_camera_doppia from '../../photos/Case/Piano terra/Armadio camera doppia.jpg';
import bagno1 from '../../photos/Case/Piano terra/Bagno 1.jpg';
import bagno2 from '../../photos/Case/Piano terra/Bagno 2.jpg';
import doccia from '../../photos/Case/Piano terra/Doccia.jpg';

import bici1 from '../../photos/Case/Primo piano/Biciclette 1.jpg';
import bici2 from '../../photos/Case/Primo piano/Biciclette 2.jpg';

const DataHousePage1 = [
    {
        src: cancello_ingresso1,
        title: 'Esterno Appartamenti',
        description: 'Cancello d\'ingresso degli appartamenti',
    },
    {
        src: cancello_ingresso2,
        title: 'Esterno Appartamenti',
        description: 'Cancello d\'ingresso degli appartamenti',
    },
    {
        src: esterno_piano_terra1,
        title: 'Esterno Piano Terra',
        description: 'Esterno della casa del piano terra',
    },
    {
        src: esterno_piano_terra2,
        title: 'Esterno Piano Terra',
        description: 'Esterno della casa del piano terra',
    },
    {
        src: esterno_piano_terra3,
        title: 'Esterno Piano Terra',
        description: 'Esterno della casa del piano terra',
    },
    {
        src: giardino1,
        title: 'Giardino',
        description: 'Giardino del piano terra',
    },
    {
        src: giardino2,
        title: 'Giardino',
        description: 'Giardino del piano terra',
    },
    {
        src: particolare_giardino1,
        title: 'Giardino',
        description: 'Particolare del giardino',
    },
    {
        src: particolare_giardino2,
        title: 'Giardino',
        description: 'Particolare del giardino',
    },
    {
        src: particolare_giardino3,
        title: 'Giardino',
        description: 'Particolare del giardino',
    },
    {
        src: particolare_giardino4,
        title: 'Giardino',
        description: 'Particolare del giardino',
    },
    {
        src: particolare_giardino5,
        title: 'Giardino',
        description: 'Particolare del giardino',
    },
    {
        src: particolare_giardino6,
        title: 'Giardino',
        description: 'Particolare del giardino',
    },
    {
        src: gradini_accesso,
        title: 'Esterno Piano Terra',
        description: 'Gradini d\'accesso',
    },
    {
        src: balconcino_ingresso,
        title: 'Esterno Piano Terra',
        description: 'Balconcino d\'ingresso',
    },
    {
        src: accesso_veranda,
        title: 'Esterno Piano Terra',
        description: 'Accesso veranda',
    },
    {
        src: veranda1,
        title: 'Esterno Piano Terra',
        description: 'Veranda',
    },
    {
        src: cucina_esterna,
        title: 'Esterno Piano Terra',
        description: 'Cucina esterna',
    },
    {
        src: barbecue,
        title: 'Esterno Piano Terra',
        description: 'Barbecue',
    },
    {
        src: cucina_interna,
        title: 'Interno Piano Terra',
        description: 'Cucina interna',
    },
    {
        src: frigo,
        title: 'Interno Piano Terra',
        description: 'Frigorifero',
    },
    {
        src: divano_soggiorno,
        title: 'Interno Piano Terra',
        description: 'Divano del soggiorno',
    },
    {
        src: tavolo_cucina,
        title: 'Interno Piano Terra',
        description: 'Tavolo della cucina',
    },
    {
        src: vista_cucina,
        title: 'Interno Piano Terra',
        description: 'Vista dalla cucina',
    },
    {
        src: camera_matr,
        title: 'Interno Piano Terra',
        description: 'Camera matrimoniale',
    },
    {
        src: armadio_camera_matr,
        title: 'Interno Piano Terra',
        description: 'Armadio della camera matrimoniale',
    },
    {
        src: camera_doppia,
        title: 'Interno Piano Terra',
        description: 'Camera doppia',
    },
    {
        src: armadio_camera_doppia,
        title: 'Interno Piano Terra',
        description: 'Armadio della camera doppia',
    },
    {
        src: bagno1,
        title: 'Interno Piano Terra',
        description: 'Bagno',
    },
    {
        src: bagno2,
        title: 'Interno Piano Terra',
        description: 'Bagno',
    },
    {
        src: doccia,
        title: 'Interno Piano Terra',
        description: 'Doccia',
    },
    {
        src: bici1,
        title: 'Biciclette',
        description: 'Biciclette',
    },
    {
        src: bici2,
        title: 'Biciclette',
        description: 'Biciclette',
    },
]
export default DataHousePage1;